import type { CoresDaMarca, Parceiro } from "./tipos"

const ESTILO_ID = "tema-do-parceiro"

const variaveis = (cores: CoresDaMarca) =>
    Object.entries(cores)
        .map(([papel, valor]) => `--color-${papel}: ${valor};`)
        .join(" ")

// O tema é um bloco de CSS que sobrescreve as variáveis que o Tailwind já lê, preso ao atributo
// `data-parceiro` para ganhar do `:root` de `index.css` por especificidade — e não por ordem de
// carregamento, que muda entre o dev e o build.
export const cssDoTema = (parceiro: Parceiro): string => {
    const seletor = `:root[data-parceiro="${parceiro.slug}"]`
    const blocos: string[] = []

    if (parceiro.tema) {
        blocos.push(`${seletor} { ${variaveis(parceiro.tema.claro)} }`)
        blocos.push(
            `@media (prefers-color-scheme: dark) { ${seletor} { ${variaveis(parceiro.tema.escuro)} } }`,
        )
    }
    if (parceiro.fontes) {
        const { titulo, texto, numeros } = parceiro.fontes
        blocos.push(
            `${seletor} { --font-display: ${titulo}; --font-sans: ${texto}; --font-num: ${numeros}; }`,
        )
    }

    return blocos.join("\n")
}

// Roda antes do primeiro render, como a captura do token: pintar a página com a marca errada e
// trocar depois é exatamente o tipo de piscada que faz o RH desconfiar de um link.
export const aplicarTema = (parceiro: Parceiro, documento: Document = document) => {
    documento.documentElement.dataset.parceiro = parceiro.slug
    documento.title = parceiro.tituloDaAba

    // Todos os rel="icon" apontam para o do parceiro: o navegador escolhe entre eles por tamanho e
    // tipo, e um que sobrasse com a Faz Cred poderia ser o escolhido.
    if (parceiro.favicon) {
        for (const link of documento.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]')) {
            link.href = parceiro.favicon
            link.removeAttribute("type")
            link.removeAttribute("sizes")
        }
    }

    documento.getElementById(ESTILO_ID)?.remove()
    const css = cssDoTema(parceiro)
    if (css) {
        const estilo = documento.createElement("style")
        estilo.id = ESTILO_ID
        estilo.textContent = css
        documento.head.appendChild(estilo)
    }

    // A fonte chega depois, e tudo bem: `font-display: swap` mostra o texto na fonte do sistema e
    // troca quando carrega. Falhar aqui não pode derrubar a página — fica a fonte do sistema.
    parceiro.fontes?.carregar().catch(() => undefined)
}
